/**
 * Created by Mark on 17/04/2017.
 */




import React  from 'react';
import CurriculumServices from '../services/curriculums-services.js';
import CurriculumStore from '../store/curriculum-store.js';
import Layout from '../components/layouts/blank-page.js';
import ListItem from '../components/lists/list-item.js';

export default class CurriculumComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {email:'', loaded:true , list:[]}
    }

    componentDidMount(){
        CurriculumServices.getAllCurriculums();
    }

    componentWillMount(){
        CurriculumStore.on("CHANGE" , () => {
            this.setState({
                list: CurriculumStore.userCurriculums
            })
        });
    }

    renderOptions(){

        var items = [];

        for(var idx = 0 ; idx < this.state.list.length; idx++)
        {
            items.push(<ListItem image={this.state.list[idx].getImage()} title={this.state.list[idx].getName()}/>)
        }

        return items;
    }

    render(){
        return (<Layout>
                    <div className="login" >
                        <div className={"l-block animate toggled"} id="l-login">
                            <div className="lb-body p-0">
                                {this.renderOptions()}
                            </div>
                        </div>
                    </div>
                </Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/curriculum-selection.js